
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css/effect-fade";



const baseUrl = process.env.REACT_APP_API_URL;


export const SlideShowScreen = ({ data }) => {

    const enableLoop = data && data.length > 1;



    return (
        <div style={styles.container}>
          <Swiper
            slidesPerView={1}
            spaceBetween={0}
            loop={enableLoop}
            pagination={{ clickable: true, dynamicBullets: true }}
            navigation={true}
            autoplay={{ delay: 6000, disableOnInteraction: false, pauseOnMouseEnter: true }}
            effect="fade"
            fadeEffect={{ crossFade: true }}
            speed={ 800 }
            modules={[Navigation, Pagination, Autoplay, EffectFade]}
            className="netflix-slideshow"
          >
            {data?.map((slide, index) => (
              <SwiperSlide key={`${slide.img}-${index}`}>
                <div style={styles.slideWrapper}>
                  <img
                    src={`${baseUrl}/uploads/slideshow/${slide.img}`}
                    alt={`Slide ${index + 1}`}
                    style={styles.image}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <style>{`
            .netflix-slideshow {
              width: 100%;
              height: 100%;
            }
            .netflix-slideshow .swiper-slide {
              background: #000;
            }
            .netflix-slideshow .swiper-button-next,
            .netflix-slideshow .swiper-button-prev {
              color: #fff;
              background: rgba(0, 0, 0, 0.5);
              width: 50px;
              height: 50px;
              border-radius: 50%;
              opacity: 0;
              transition: all 0.3s ease;
            }
            .netflix-slideshow:hover .swiper-button-next,
            .netflix-slideshow:hover .swiper-button-prev {
              opacity: 1;
            }

            .netflix-slideshow .swiper-button-next:hover,
            .netflix-slideshow .swiper-button-prev:hover {
              background: rgba(0, 0, 0, 0.8);
              transform: scale(1.1);
            }
            .netflix-slideshow .swiper-button-next:after,
            .netflix-slideshow .swiper-button-prev:after {
              font-size: 22px;
              font-weight: bold;
            }
            .netflix-slideshow .swiper-pagination {
              bottom: 30px;
            }
            .netflix-slideshow .swiper-pagination-bullet {
              width: 12px;
              height: 12px;
              background: #fff;
              opacity: 0.5;
              transition: all 0.3s ease;
            }
            .netflix-slideshow .swiper-pagination-bullet-active {
              opacity: 1;
              background: #e50914;
              width: 30px;
              border-radius: 6px;
            }

              @media (max-width: 768px) {
              .netflix-slideshow {
                height: 100%;
              }

              .netflix-slideshow .swiper-button-next,
              .netflix-slideshow .swiper-button-prev {
                width: 40px;
                height: 40px;
              }

              .netflix-slideshow .swiper-button-next:after,
              .netflix-slideshow .swiper-button-prev:after {
                font-size: 18px;
              }

              .netflix-slideshow .swiper-pagination {
                bottom: 20px;
              }
            }

            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
    );
};



const styles = {
    container: {
      width: '100%',
      backgroundColor: '#000',
      position: 'relative',
      overflow: 'hidden',
      height: '90vh',
    },
    slideWrapper: {
      width: '100%',
      height: '100%',
      position: 'relative',
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
    overlay: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '150px',
      background: 'linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0) 100%)',
      pointerEvents: 'none',
    },
    loadingContainer: {
      width: '100%',
      height: '100%',
      minHeight: '400px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#141414',
    },
    loadingSpinner: {
      width: '50px',
      height: '50px',
      border: '4px solid rgba(229, 9, 20, 0.3)',
      borderTop: '4px solid #e50914',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
};